import { Controller } from "@hotwired/stimulus";

// VIP ("Guld") upgrade comparison in step3/_vip_header.html.erb. Three
// mutually exclusive states: the side-by-side comparison, "chosen: with
// upgrade" (with a comment box), "chosen: without upgrade" (with a chance
// to change your mind) -- matching the original's upgrade_div /
// with_upgrade_choosen / without_upgrade_choosen show/hide dance.
export default class extends Controller {
  static targets = ["comparison", "withChosen", "withoutChosen"];

  chooseWithout() {
    this.setUpgrade("0");
    this.comparisonTarget.classList.add("hidden");
    this.withoutChosenTarget.classList.remove("hidden");
    this.dispatchChanged();
  }

  chooseWith() {
    this.setUpgrade("1");
    this.comparisonTarget.classList.add("hidden");
    this.withChosenTarget.classList.remove("hidden");
    this.dispatchChanged();
  }

  backToComparison() {
    this.comparisonTarget.classList.remove("hidden");
    this.withChosenTarget.classList.add("hidden");
  }

  reconsiderWithUpgrade() {
    this.setUpgrade("1");
    this.withoutChosenTarget.classList.add("hidden");
    this.withChosenTarget.classList.remove("hidden");
    this.dispatchChanged();
  }

  setUpgrade(value) {
    const field = document.querySelector('input[name="upgrade"]');
    if (field) field.value = value;
  }

  dispatchChanged() {
    this.element.dispatchEvent(new CustomEvent("upgrade:changed", { bubbles: true }));
  }
}
